module.exports = __webpack_public_path__ + "static/media/bakery.7e2af7cb.svg";